import { ErrorHandler, Injectable, Injector } from '@angular/core';
import * as firebase from "firebase";
// import * as Raven from 'raven-js';
import * as StackTrace from 'stacktrace-js';

import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { DeviceDetectorService } from 'ngx-device-detector';
// import * as StackTrace from 'stacktrace-js';
@Injectable()
export class MyErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {

  }
  handleError(error: any): void {
    const location = this.injector.get(LocationStrategy);
    const message = error.message ? error.message : error.toString();
    const url = location instanceof PathLocationStrategy
      ? location.path() : '';
    // get the stack trace, lets grab the last 10 stacks only
    StackTrace.fromError(error).then(stackframes => {
      const stack = stackframes.splice(0, 20);
      const stackString = stack
        .map(function (sf) {
          return sf.toString();
        }).join('\n');
      const deviceService = this.injector.get(DeviceDetectorService);
      let platform = "unknown";
      if (deviceService.isMobile()) platform = "mobile";
      if (deviceService.isDesktop()) platform = "desktop";
      if (deviceService.isTablet()) platform = "tablet";
      // log on the server
      firebase.database().ref("errors/" + (message).replace(/(?:\.|\[|\#|\]|\$)/g, "")).push({
        message, url, stack: stack, stackString: stackString, user: localStorage.getItem("currentUserId"), time: {
          localString: new Date().toLocaleString(),
          timestamp: Date.now()
        },
        deviceInfo: { ...deviceService.getDeviceInfo(), platform }
      });
    });
    // Raven.captureException(error.originalError || error);
    console.error(error);
    throw error;
  }
}


// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/_classes/error-handler.ts